var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "withdraw md-layout md-alignment-center-center" },
    [
      _c("div", { staticClass: "container-header" }, [
        _c("div", { staticClass: "container-header__title" }, [
          _vm._v(_vm._s(_vm.i18n.topup_refill()))
        ])
      ]),
      _vm._v(" "),
      _vm.state
        ? [
            _c(
              "md-card",
              {
                staticClass:
                  "container container_40 withdraw__success-msg md-layout-item md-size-50 md-medium-size-45 md-small-size-100 md-xsmall-size-100"
              },
              [
                _c("div", { staticClass: "md-title" }, [
                  _vm._v(_vm._s(_vm.i18n.topup_request()))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "withdraw__success-amount" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getTopUpRequestStatus) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass: "btn md-primary",
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/topup-balance/make")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.i18n.lbl_go_back()) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass: "btn md-primary",
                        attrs: { to: "/history" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.i18n.lbl_view_history()) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        : [
            _vm.view.mode === _vm.VIEW_MODES.submit && _vm.tokenCodes.length
              ? [
                  _vm.isCryptoToken(_vm.form.tokenCode)
                    ? [
                        _c(
                          "md-card",
                          { staticClass: "container container_40" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "withdraw__user-balance text_medium"
                              },
                              [
                                _c("p", { staticClass: "bold" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.i18n.lbl_current_balance({
                                          amount: _vm.greyWhiteTronSum,
                                          asset: _vm.formatToken
                                        })
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.i18n.white_wallet()) +
                                      ": " +
                                      _vm._s(_vm.swimBalance) +
                                      " " +
                                      _vm._s(_vm.formatToken)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.i18n.gray_wallet()) +
                                      ": " +
                                      _vm._s(_vm.greyTronValue) +
                                      " " +
                                      _vm._s(_vm.formatToken)
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "withdraw__explanations text_large"
                                  },
                                  [
                                    _vm.minAmounts[_vm.form.tokenCode]
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.i18n.topup_how_much({
                                                  asset: _vm.formatToken,
                                                  value:
                                                    _vm.minAmounts[
                                                      _vm.form.tokenCode
                                                    ]
                                                })
                                              ) +
                                              ".\n                " +
                                              _vm._s(
                                                _vm.i18n.topup_crypto_minimal()
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.i18n.topup_network_fee()
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout withdraw__flex-wrapper"
                                  },
                                  [
                                    _c("select-field3", {
                                      staticClass:
                                        "md-layout-item withdraw__select",
                                      attrs: {
                                        label: _vm.i18n.lbl_choose_asset(),
                                        values: _vm.tokensCodeFormatted
                                      },
                                      model: {
                                        value: _vm.form.tokenCode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "tokenCode", $$v)
                                        },
                                        expression: "form.tokenCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.currentQr && !_vm.cryptoAddres
                                  ? [
                                      _c("div", { staticClass: "wrapform" }, [
                                        _c(
                                          "div",
                                          { staticClass: "wrapform-w" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "timer-wrap" },
                                              [_c("Timer")],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "app__dialog-inner",
                                                staticStyle: {
                                                  "justify-content": "center"
                                                }
                                              },
                                              [
                                                _c("clipboard-field", {
                                                  staticClass:
                                                    "account-id__clipboard",
                                                  attrs: {
                                                    value: _vm.currentQr
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.createBtn
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "md-button btn md-primary create-btn md-button-small",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: _vm.resetQrByBtn
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "md-ripple"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "md-button-content"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.i18n.lbl_create_btn()
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "md-layout withdraw__flex-wrapper",
                                                staticStyle: {
                                                  "justify-content": "center"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "cash-header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.i18n.lbl_your_wallet()
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("qrcode", {
                                              style:
                                                "width: 250px; height: 250px; overflow: hide; margin: 0px auto !important;",
                                              attrs: {
                                                text: _vm.currentQr,
                                                size: 250,
                                                color: "#3f4244",
                                                align: "center"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  : _vm.cryptoAddres !== "" && !_vm.noAddres
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout withdraw__flex-wrapper",
                                          staticStyle: {
                                            "justify-content": "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "cash-header" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.i18n.lbl_your_wallet()
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "app__dialog-inner",
                                          staticStyle: {
                                            "justify-content": "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "qrcode-wrap" },
                                            [
                                              _c("qrcode", {
                                                style:
                                                  "width: 250px; height: 250px; overflow: hide; margin: 0px auto !important;",
                                                attrs: {
                                                  text: _vm.cryptoAddres,
                                                  size: 250,
                                                  color: "#3f4244",
                                                  align: "center"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("clipboard-field", {
                                                staticClass:
                                                  "account-id__clipboard",
                                                attrs: {
                                                  value: _vm.cryptoAddres
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm.noAddres
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout withdraw__flex-wrapper",
                                          staticStyle: {
                                            "justify-content": "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "cash-header" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.i18n.lbl_no_data())
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout withdraw__flex-wrapper",
                                          staticStyle: {
                                            "justify-content": "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "cash-header" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.i18n.lbl_loading())
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    : [
                        _c(
                          "form",
                          {
                            staticClass:
                              "md-layout-item md-size-50 md-medium-size-75 md-small-size-95 md-xsmall-size-100",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.submit.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              { staticClass: "container container_40" },
                              [
                                _vm.isPending
                                  ? _c("md-progress-bar", {
                                      attrs: { "md-mode": "indeterminate" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "withdraw__user-balance text_medium"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.i18n.lbl_current_balance({
                                            amount: _vm.roundCurrency(
                                              _vm.balance !== undefined
                                                ? _vm.balance.balance
                                                : 0,
                                              _vm.form.tokenCode
                                            ),
                                            asset: _vm.assetIcon(
                                              _vm.form.tokenCode
                                            )
                                          })
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "withdraw__explanations text_large"
                                    },
                                    [
                                      _vm.minAmounts[_vm.form.tokenCode]
                                        ? [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.i18n.topup_how_much({
                                                    asset: _vm.form.tokenCode,
                                                    value:
                                                      _vm.minAmounts[
                                                        _vm.form.tokenCode
                                                      ]
                                                  })
                                                ) +
                                                ".\n                  " +
                                                _vm._s(
                                                  _vm.i18n.topup_minimal()
                                                ) +
                                                ".\n                "
                                            )
                                          ]
                                        : [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.i18n.topup_network_fee()
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout withdraw__flex-wrapper"
                                    },
                                    [
                                      _c("select-field3", {
                                        staticClass:
                                          "md-layout-item withdraw__select",
                                        attrs: {
                                          id: "wow",
                                          label: _vm.i18n.lbl_choose_asset(),
                                          values: _vm.tokensCodeFormatted
                                        },
                                        model: {
                                          value: _vm.form.tokenCode,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "tokenCode", $$v)
                                          },
                                          expression: "form.tokenCode"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item withdraw__field"
                                        },
                                        [
                                          _c("input-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|amount",
                                                expression: "'required|amount'"
                                              }
                                            ],
                                            staticClass: "field__number",
                                            attrs: {
                                              label: _vm.i18n.lbl_amount(),
                                              name: "amount",
                                              type: "number",
                                              title: "Amount",
                                              align: "right",
                                              vvValidateOn: "change",
                                              errorMessage:
                                                _vm.errors.first("amount") ||
                                                (_vm.lessThenMinimumAmount
                                                  ? _vm.i18n.topup_error_minimum_amount(
                                                      {
                                                        value:
                                                          _vm.minAmounts[
                                                            _vm.form.tokenCode
                                                          ],
                                                        asset:
                                                          _vm.form.tokenCode
                                                      }
                                                    )
                                                  : "")
                                            },
                                            on: { blur: _vm.checkAmount },
                                            model: {
                                              value: _vm.form.amount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "amount",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "form.amount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.form.tokenCode ===
                                    _vm.CRYPTO_CURRENCYS.ETH ||
                                  _vm.form.tokenCode ===
                                    _vm.CRYPTO_CURRENCYS.BTC
                                    ? _c(
                                        "div",
                                        [
                                          _c("input-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  "required|wallet_address",
                                                expression:
                                                  "'required|wallet_address'"
                                              }
                                            ],
                                            staticClass: "md-layout-item",
                                            attrs: {
                                              label: _vm.getDirections(
                                                _vm.TOP_UP_BALANCE_DIRECTION
                                                  .external
                                              ),
                                              name: "wallet-address",
                                              errorMessage:
                                                _vm.errors.first(
                                                  "wallet-address"
                                                ) ||
                                                (_vm.isTryingToSendToYourself
                                                  ? _vm.i18n.topup_error_is_trying_to_send_to_yourself()
                                                  : "")
                                            },
                                            model: {
                                              value: _vm.form.wallet,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "wallet",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "form.wallet"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm.form.tokenCode === "UAH" &&
                                      (_vm.userTaurus.length > 0 ||
                                        _vm.userUplataInsha.length > 0 ||
                                        _vm.userXpay.length > 0)
                                    ? _c(
                                        "div",
                                        [
                                          _c("select-field", {
                                            staticClass: "md-layout-item",
                                            attrs: {
                                              label: _vm.isEmptyCard
                                                ? _vm.i18n.topup_add_xpay_card()
                                                : _vm.i18n.topup_withdraw(),
                                              name: "direction",
                                              title: "direction",
                                              disabled: _vm.isEmptyCard,
                                              values: _vm.directionList
                                            },
                                            model: {
                                              value: _vm.form.direction,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "direction",
                                                  $$v
                                                )
                                              },
                                              expression: "form.direction"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm.isCashable
                                    ? _c(
                                        "div",
                                        [
                                          _c("input-field", {
                                            staticClass: "md-layout-item",
                                            attrs: {
                                              name: "direction",
                                              readonly: true,
                                              value: _vm.getDirections(
                                                _vm.TOP_UP_BALANCE_DIRECTION
                                                  .cashbox
                                              )
                                            },
                                            model: {
                                              value: _vm.form.direction,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "direction",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "form.direction"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c("input-field", {
                                            staticClass: "md-layout-item",
                                            attrs: {
                                              name: "direction",
                                              readonly: true,
                                              value: _vm.getDirections(
                                                _vm.TOP_UP_BALANCE_DIRECTION
                                                  .nothere
                                              )
                                            },
                                            model: {
                                              value: _vm.form.direction,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "direction",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "form.direction"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "btn-wrap" },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "btn md-primary md-yellow w-100",
                                        attrs: {
                                          type: "submit",
                                          disabled:
                                            !_vm.isCashable || _vm.isEmptyCard
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.i18n.topup_topup()) +
                                            "\n              >"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.view.mode === _vm.VIEW_MODES.success
              ? [
                  _c(
                    "md-card",
                    {
                      staticClass:
                        "withdraw__success-msg md-layout-item md-size-50 md-medium-size-45 md-small-size-100 md-xsmall-size-100"
                    },
                    [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v(_vm._s(_vm.i18n.topup_success()))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btn-wrap" },
                        [
                          _c(
                            "div",
                            { staticClass: "withdraw__success-amount" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(this.normalizeAmount()) +
                                  " " +
                                  _vm._s(_vm.form.tokenCode) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "btn md-primary",
                              on: {
                                click: function($event) {
                                  return _vm.updateView(
                                    _vm.VIEW_MODES.submit,
                                    {},
                                    true
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.i18n.lbl_go_back()) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "btn md-primary",
                              attrs: {
                                to: "/history/index/" + _vm.form.tokenCode
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.i18n.lbl_view_history()) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.view.mode === _vm.VIEW_MODES.otpConfirm
              ? [
                  _c(
                    "md-card",
                    {
                      staticClass:
                        "withdraw__success-msg md-layout-item md-size-50 md-medium-size-45 md-small-size-100 md-xsmall-size-100"
                    },
                    [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v(_vm._s(_vm.i18n.topup_otp_code_confirm()))
                      ])
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.view.mode === _vm.VIEW_MODES.secureConfirm
              ? [
                  _c(
                    "md-card",
                    {
                      staticClass:
                        "withdraw__success-msg md-layout-item md-size-50 md-medium-size-45 md-small-size-100 md-xsmall-size-100"
                    },
                    [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v(_vm._s(_vm.i18n.topup_success()))
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("\n          ...............\n          "),
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.view.opts.form) }
                        })
                      ])
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            !_vm.tokenCodes.length
              ? [
                  _c(
                    "md-card",
                    {
                      staticClass:
                        "md-layout-item md-size-50 md-medium-size-65 md-small-size-95 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "container__no-data" },
                        [
                          _c("md-icon", { staticClass: "md-size-4x" }, [
                            _vm._v("credit_card")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text_large" }, [
                            _vm._v(_vm._s(_vm.i18n.topup_no_assets()))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text_description text_margin text_medium"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.i18n.topup_no_assets_exp()) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-227808d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227808d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/topupBalance/make/TopupBalance.Make.vue
// module id = ic4J
// module chunks = 1